export const numberOfGeneratedSteps = 5;
export const scopeStep = 'scope';
export const typeOfAppStep = 'type';
export const rolesSuggestionStep = 'rolesSuggestion';
export const rolesStep = 'roles';
export const userFlowsStep = 'userFlows';
export const contentBlocksSuggestionStep = 'contentBlocksSuggestion';
export const contentBlocksStep = 'contentBlocks';
export const schemaStep = 'schema';
// TODO: move steps to zod definition in specificationSlice
export const steps = {
    name: 'name',
    intent: 'intent',
    scope: scopeStep,
    type: typeOfAppStep,
    schema: schemaStep,
    schemaOrigin: 'schemaOrigin',
    schemaDsl: 'schemaDsl',
};
export const cmsType = 'Headless CMS';
export const erpType = 'Event ERP';
export const crmType = 'CRM';
export const b2bType = 'B2B portal';
export const membershipType = 'Membership management';
export const reservationType = 'Reservation management';
export const contractType = 'Contract management';
export const orderType = 'Order management';
export const assetType = 'Asset management';
export const complianceType = 'Compliance';
export const intranetType = 'Internal information system';
export const dashboardType = 'Domain specific dashboard';
export const marketplaceType = 'Marketplace';
export const genericType = 'Generic application';
export const applicationTypesMap = {
    cms: cmsType,
    crm: crmType,
    generic: genericType,
    all: 'All CRUD pages',
};
//# sourceMappingURL=types.js.map